// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"4b1db78a","595":"9f558e09","905":"4f61dad2"}[chunkId] + ".chunk.js";
};